import { BusinessRules } from '../BusinessRules';

const rules: Partial<BusinessRules> = {};

export default rules;
